import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';

function App() {
  const [address, setAddress] = useState('');
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    if (isValidAddress(address)) {
      fetchTransactions(address);
    }
  }, [address]);

  const isValidAddress = (address) => {
    return /^0x[a-fA-F0-9]{40}$/.test(address);
  };

  const fetchTransactions = async (address) => {
    try {
      const response = await axios.get(`https://api.scan.pulsechain.com/api/v2/addresses/${address}/transactions?filter=to%20%7C%20from`);
      if (response.data && response.data.items) {
        const transactions = response.data.items.slice(0, 20);
        setTransactions(transactions);
      } else {
        console.error('Unexpected response format');
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#282c34', color: 'white'}}>
      <div style={{marginBottom: '20px'}}>
        <input 
          type="text"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          placeholder="Enter Ethereum address"
          style={{marginRight: '10px', padding: '10px'}}
        />
        <button
          disabled={!isValidAddress(address)}
          onClick={() => fetchTransactions(address)}
          style={{backgroundColor: 'dodgerblue', color: 'white', padding: '10px'}}
        >
          Fetch Transactions
        </button>
      </div>
      {transactions.map((transaction, index) => (
        <div key={index} style={{border: '1px solid white', margin: '10px', padding: '10px', backgroundColor: transaction.status === "ok" ? "darkgreen" : "darkred"}}>
          <p style={{margin: '0'}}>Block number: {transaction.block}</p>
          <p style={{margin: '0'}}>Gas Used: {transaction.gas_used}</p>
          <p style={{margin: '0'}}>Gas Price: {transaction.gas_price}</p>
          <p style={{margin: '0'}}>Hash: {transaction.hash}</p>
          <p style={{margin: '0'}}>Method: {transaction.method}</p>
          <p style={{margin: '0'}}>To: {transaction.to.hash} {transaction.to.is_contract === true ? 'Contract' : 'Address'}</p>
          <p style={{margin: '0'}}>TX Type: {transaction.tx_types && transaction.tx_types.length > 0 ? transaction.tx_types.join(', ') : 'N/A'}</p>
          {transaction.method === 'transfer' && transaction.to.is_contract === true && transaction.decoded_input.parameters && (
            <p style={{margin: '0'}}>To address: {transaction.decoded_input.parameters[0].value}</p>
          )}
          <p style={{margin: '0'}}>Contract: {transaction.to.name}</p>
          <p style={{margin: '0'}}>Nonce: {transaction.nonce}</p>
          <p style={{margin: '0'}}>Time: {moment(transaction.timestamp).format("MM/DD/YYYY HH:mm:ss")}</p>
          <p style={{margin: '0'}}>Status: {transaction.status}</p>
        </div>
      ))}
    </div>
  );
}

export default App;
